import permissions from '../../config/permissions';
import i18next from 'i18next';
import { CUSTOM_TAGS_OPTIONS, PATIENT_CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import { INFO_PANE_PAGES } from '../../redux_store';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

const genderItems = [
  { label: i18next.t('forms:female'), value: 'female' },
  {
    label: i18next.t('forms:male'),
    value: 'male',
  },
];

export default genderItems;

export const PATIENT_LANGUAGE = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
  UNKNOWN: 'unknown',
};

export const PATIENT_LANGUAGE_BY_KEY = {
  [PATIENT_LANGUAGE.ENGLISH]: 'English',
  [PATIENT_LANGUAGE.SPANISH]: 'Spanish',
  [PATIENT_LANGUAGE.UNKNOWN]: 'Unknown',
};

export const PATIENT_LANGUAGE_SELECTOR_OPTIONS = [
  {
    label: 'English',
    value: PATIENT_LANGUAGE.ENGLISH,
  },
  {
    label: 'Spanish',
    value: PATIENT_LANGUAGE.SPANISH,
  },
  {
    label: 'Unknown',
    value: PATIENT_LANGUAGE.UNKNOWN,
  },
];

export const PATIENT_RACE = {
  NON_HISPANIC_WHITE: 'Non-Hispanic White / Caucasian',
  HISPANIC_LATINO: 'Hispanic / Latino',
  AFRICAN_AMERICAN_BLACK: 'African American Black',
  ASIAN: 'Asian',
  AMERICAN_INDIAN_ALASKA_NATIVE: 'American Indian or Alaska Native',
  NATIVE_HAWAIIAN_PACIFIC_ISLANDER: 'Native Hawaiian or Other Pacific Islander',
  MIDDLE_EASTERN_NORTH_AFRICAN: 'Middle Eastern or North African',
  MULTIRACIAL_OTHER: 'Multiracial or none of the above',
};

export const PATIENT_RACE_BY_KEY = {
  [PATIENT_RACE.NON_HISPANIC_WHITE]: 'Non-Hispanic White / Caucasian',
  [PATIENT_RACE.HISPANIC_LATINO]: 'Hispanic / Latino',
  [PATIENT_RACE.AFRICAN_AMERICAN_BLACK]: 'African American Black',
  [PATIENT_RACE.ASIAN]: 'Asian',
  [PATIENT_RACE.AMERICAN_INDIAN_ALASKA_NATIVE]: 'American Indian or Alaska Native',
  [PATIENT_RACE.NATIVE_HAWAIIAN_PACIFIC_ISLANDER]: 'Native Hawaiian or Other Pacific Islander',
  [PATIENT_RACE.MIDDLE_EASTERN_NORTH_AFRICAN]: 'Middle Eastern or North African',
  [PATIENT_RACE.MULTIRACIAL_OTHER]: 'Multiracial or none of the above',
};

export const PATIENT_RACE_SELECTOR_OPTIONS = [
  {
    label: 'Non-Hispanic White / Caucasian',
    value: PATIENT_RACE.NON_HISPANIC_WHITE,
  },
  {
    label: 'Hispanic / Latino',
    value: PATIENT_RACE.HISPANIC_LATINO,
  },
  {
    label: 'African American Black',
    value: PATIENT_RACE.AFRICAN_AMERICAN_BLACK,
  },
  {
    label: 'Asian',
    value: PATIENT_RACE.ASIAN,
  },
  {
    label: 'American Indian or Alaska Native',
    value: PATIENT_RACE.AMERICAN_INDIAN_ALASKA_NATIVE,
  },
  {
    label: 'Native Hawaiian or Other Pacific Islander',
    value: PATIENT_RACE.NATIVE_HAWAIIAN_PACIFIC_ISLANDER,
  },
  {
    label: 'Middle Eastern or North African',
    value: PATIENT_RACE.MIDDLE_EASTERN_NORTH_AFRICAN,
  },
  {
    label: 'Multiracial or none of the above',
    value: PATIENT_RACE.MULTIRACIAL_OTHER,
  },
];

export const PATIENTS_COLUMNS = [
  {
    size: 270,
    header: i18next.t('tables:accountCustomTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: PATIENT_CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'mrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:firstName'),
    accessorKey: 'firstName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:lastName'),
    accessorKey: 'lastName',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:dateOfBirth'),
    accessorKey: 'dateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
];
